import { Component } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-email',
	templateUrl: 'fn-grid-email.component.html',
	styleUrls: ['fn-grid-email.component.scss'],
})
export class FnGridEmailComponent extends FnGridAbstractCell {}
